<template>
  <div >
    <b-modal
      no-close-on-backdrop
      centered
      hide-footer
      size="lg"
      v-model="open"
      :title="` Detalhes do Orçamento ${table.records.id}`"
      :busy="loading"
    >
    <b-row>
      <b-col cols="12">
        <h5>Dados do Cliente</h5>
      </b-col>
      <b-col cols="6">
        <span> <strong>Nome: </strong> {{ table.records.name_client }}</span>
      </b-col>
      <b-col cols="6">
        <span> <strong>Whatsapp: </strong> {{ table.records.whatsapp_client }}</span>
      </b-col>
      
      <b-col cols="12" class="mt-4">
        <h5>Produtos</h5>
      </b-col>

      <b-col cols="12" class="mt-2">
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="table.records.products"
          :busy="loading"
          empty-text="Nenhum produto encontrado"
        >
        <template #cell(photo)="data">
          <img
            :src="
              linkFotos(data.item.origem) +
              data.item.product_photo[0].foto_png
            "
            width="50px"
          />
        </template>

        <!-- <template #cell(value)="data">
          <span>{{ formatMoney(data.item.selected_product[0].price_sales_format_1) }}</span>
        </template> -->

        <template #cell(quantity)="data">
          <span>{{ data.item.quantity}}</span>
        </template>

        <template #cell(product)="data">
          <span>{{ data.item.products_details[0].produto}}</span>
        </template>

        <template #cell(codbar)="data">
          <span>{{ data.item.products_details[0].codbar}}</span>
        </template>
        </b-table>
      </b-col>

    </b-row>
    </b-modal>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';

export default {
  name: 'ModalDetalheOrcamentoWhatsapp',
  mixins: [makeToast],

  data() {
    return {
      loading: false,
      open: false,
      table: {
        headers: [
          {
            key: 'id',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Foto',
            sortable: false,
          },
          {
            key: 'product',
            label: 'Produto',
            sortable: false,
          },
          {
            key: 'codbar',
            label: 'Cód. Barras ',
            sortable: false,
          },
          {
            key: 'quantity',
            label: 'Qtde ',
            sortable: false,
          },
          // {
          //   key: 'value',
          //   label: 'Valor ',
          //   sortable: false,
          // },
        ],
        records: [],
      },
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  methods: {
    toggleOpen({ dataBudget = []}) {
      this.open = !this.open;
      this.table.records = dataBudget;
    },
    formatMoney(value) {
      var money = parseFloat(value);
      return money.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    linkFotos(origem) {
      if (origem === 'Belenus') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } 
      return process.env.VUE_APP_FOTOS_URL;
    },
  },
};
</script>